module.exports = {
      id: "search_black-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#search_black",
      toString: function () {
        return this.url;
      }
    }